.sticker {
  margin: 0; /* <figure> carries a UA default margin (1em 40px); the shared reset doesn't zero it */
  display: flex;
  flex-direction: column;
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  border: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  border-radius: 16px;
  overflow: hidden;
  box-shadow: var(--plume-shadow-card, 6px 6px 0 var(--color-primary-grey-900));
  transition:
    box-shadow 0.22s ease,
    transform 0.22s ease;
}

.sticker:hover {
  box-shadow: var(--plume-shadow-card-hover, 10px 10px 0 var(--color-complementary-yellow)); /* accent (yellow) sticker shadow */
  transform: var(--plume-hover-shift, translate(-2px, -2px));
}

.sticker__stage {
  aspect-ratio: 1 / 1;
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  border-bottom: 1px solid var(--color-primary-sand-200); /* PRIMARY_SAND_200 (neutral divider on the white stage) */
  position: relative;
}

.sticker__stage img {
  /* Absolutely sized (a 4px inset) so the artwork letterboxes inside the square stage rather than
     stretching it taller — keeps every sticker's stage the same height regardless of aspect ratio. */
  position: absolute;
  inset: 4px;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  object-fit: contain;
  transition: transform 0.35s ease;
}

.sticker:hover .sticker__stage img {
  transform: scale(1.05);
}

.sticker__foot {
  padding: 16px 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sticker__name {
  font-size: 15px;
  font-weight: 700;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  line-height: 1.25;
  margin: 0;
}

/* Variant picker (e.g. "Objectif" values) — swaps the preview + downloads within the card. */
.variant {
  display: flex;
  align-items: center;
  gap: 10px;
}

.variant__label {
  flex: none;
  font-size: 11px; /* COPY_XS */
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-text-tertiary); /* text-3 */
}

.variant__select {
  flex: 1;
  min-width: 0;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  border: 2px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  border-radius: 9999px;
  padding: 7px 12px;
  cursor: pointer;
}

/* Wraps so the two chips stack (each grows to full width) instead of overflowing the card when it's
   too narrow to hold them side by side — e.g. the 2-up sticker grid on small phones. */
.sticker__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.chip {
  flex: 1;
  /* min-width forces the wrap (rather than an internal text clip) once two chips no longer fit. */
  min-width: 84px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px 10px;
  font-size: 11px; /* COPY_XS */
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-radius: 9999px;
  border: 2px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  cursor: pointer;
  font-family: inherit;
  transition: all 0.18s ease;
}

.chip:hover {
  background: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW (accent) */
  border-color: var(--color-primary-grey-900);
  color: var(--color-primary-grey-900); /* accent-on */
}

.chipPrimary {
  background: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  color: var(--color-primary-grey-000);
}

.chipPrimary:hover {
  background: var(--color-primary-grey-700); /* PRIMARY_GREY_700 (ink-soft) */
  border-color: var(--color-primary-grey-900);
  color: var(--color-primary-grey-000);
}
